<template>
  <div class="feed-message" :class="{'my-message': message.is_mine, 'sending': message.message_id == null, 'error': message.sending_error != null}">
    <div class="avatar" :style="{backgroundColor: message.user_background_color}"> {{message.user_initials}} </div>
    <div class="content-wrapper mx-2 position-relative">

      <div class="px-3 pt-2">
        <b>{{message.user_name}}</b> &nbsp; 
        <span style="color: #777">{{shortTimestamp(message.message_creation_datetime)}}</span>
      </div>

      <div v-if="message.message_type == '1'" class="px-3 pb-2 pt-1">
        <div v-html="advancedFormat(message.message_content)"></div>
        <div v-if="message.files != null && message.files.length > 0">
          <div v-for="(file, index2) in message.files" :key="index2">

            <div v-if="isFileImage(file)">
              <fancy-box :href="fileAttachmentImage(file)" style="width: 100%; height: 100%">
                <img :src="fileAttachmentThumbnail(file)" alt="" style="width: 100%; height: 100%; object-fit: contain">
              </fancy-box>
            </div>
            <div class="feed-file" v-else>
                      
              <div class="feed-file-thumbnail">
                <a v-if="isFilePdf(file) || isFileText(file)" :href="filePreviewLink(file)" target="_blank" style="width: 100%; height: 100%; display: block">
                  <img :src="fileAttachmentThumbnail(file)" alt="" style="width: 100%; height: 100%; object-fit: contain">
                </a>
                <a v-else href="javascript:;" @click="downloadFile(file)" style="width: 100%; height: 100%; display: block">
                  <img :src="fileAttachmentThumbnail(file)" alt="" style="width: 100%; height: 100%; object-fit: contain">
                </a>
              </div>

              <div class="flex-grow-1 h-100">
                <div class="bold">{{file.file_title}}</div>
                <div>
                  <span>
                    <a href="javascript:;" @click="downloadFile(file)" v-if="file.file_id != null">Télécharger</a>
                    <span v-else>Téléchargement...</span>
                  </span>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
      <div v-else-if="message.message_type == '2'" class="px-3 pb-2 pt-1"><i class="icon-login font-green-jungle"></i> L'utilisateur a joint cette conversation.</div>
      <div v-else-if="message.message_type == '3'" class="px-3 pb-2 pt-1"><i class="icon-logout font-red"></i> L'utilisateur a quitté cette conversation.</div>

      <div class="position-absolute my-message-actions" style="top: -5px; right: 5px;">
        <button class="btn btn-sm red" style="padding: 1px 5px; border-radius: 15px;" @click="deleteMessageAsk($event, message)"><i class="fa fa-trash"></i></button>
      </div>

    </div>
    <div v-if="message.message_id == null">
      <img :src="spinnerSVG" v-if="message.sending_error === undefined" style="height: 20px">
      <span v-else class="font-red text-right">
        {{message.sending_error}}<br>
        <a href="javascript:;" v-if="message.files === undefined" @click="resendMessage($event, message)" class="text-right">Renvoyer</a>
      </span>
    </div>
  </div>
</template>

<script>
  import FancyBox from '../FancyBox.vue';
  export default {
    name: "feed-message",
    components: {
      FancyBox,
    },
    props: {
      message: {
        type: Object,
        required: true 
      },
      fileAttachmentImageUrl: {
        type: String,
        required: true 
      },
      fileAttachmentThumbnailUrl: {
        type: String,
        required: true 
      },
      fileAttachmentDownloadUrl: {
        type: String,
        required: true 
      }
    },
    computed: {
      spinnerSVG() {
        return `${window.baseUrl}assets/global/img/spinner.svg`;
      },
      shortTimestamp() {
        return (date) => {
          return moment(date).format("DD MMM à HH:mm");
        }
      },
      longTimestamp() {
        return (date) => {
          return moment(date).format("DD MMM YYYY à HH:mm");
        }
      },
      fileAttachmentImage() {
        return (file) => {
          return `${window.baseUrl}${this.fileAttachmentImageUrl.replace("%fileid%", file.file_id)}`
        }
      },
      fileAttachmentThumbnail() {
        return (file) => {
          if(file.file_id === null){
            return `${window.baseUrl}assets/global/img/spinner.svg`
          } else {
            return `${window.baseUrl}${this.fileAttachmentThumbnailUrl.replace("%fileid%", file.file_id)}`
          }
        }
      },
      isFilePdf() {
        return (file) => {
          if(file.file_mime == null) return false;
          return file.file_mime === "application/pdf";
        }
      },
      isFileText() {
        return (file) => {
          if(file.file_mime == null) return false;
          return file.file_mime.indexOf("text/") !== -1;
        }
      },
      isFileImage() {
        return (file) => {
          if(file.file_mime == null) return false;
          return file.file_mime.indexOf("image/") !== -1;
        }
      },
      filePreviewLink() {
        return (file) => {
          if(file.file_id == null) return "";
          return `${window.baseUrl}${this.fileAttachmentDownloadUrl.replace("%fileid%", file.file_id)}`
        }
      }
    },
    methods: {
      resendMessage(evt, message) {
        this.$emit("resendMessage", message.original);
      },
      deleteMessageAsk(evt, message) {
        let that = this;

        if(evt.shiftKey) {
          that.$emit("deleteMessage", message.original);
        } else {
          bootbox.dialog({
            title: "Supprimer votre message",
            message: `Voulez-vous vraiment supprimer votre message?`,
            buttons: {
              confirm: {
                label: "Supprimer",
                className: "red",
                callback: async function() {
                  that.$emit("deleteMessage", message.original);
                }
              },
              cancel: {
                label: "Annuler",
                className: "secondary",
                callback: function() {},
              }
            }
          })
        }

      },
      downloadFile(file) {
        window.location.href = this.filePreviewLink(file);
      },
    }
  }
</script>

<style lang="scss" scoped>

.feed-message {
  margin-top: 10px;
  display: flex;
  padding: 0 15px;

  .content-wrapper {
    border-radius: 5px;
    background-color: rgba(0,0,0,0.1);
  }

  .my-message-actions {
    display: none;
  }

  &.my-message {
    flex-direction: row-reverse;

    &:hover .my-message-actions {
      display: block;
    }
  }

  &.sending {
    opacity: 0.7;

    .feed-file {
      pointer-events: none;
    }
  }

  &.error {
    opacity: 1;

    .content-wrapper {
      background-color: rgba(255, 0, 0, 0.2);
    }
  }
}

.avatar {
  border-radius: 100px;
  font-size: 18px;
  background-color: rgb(21, 89, 121);
  color: white;
  text-transform: uppercase;
  padding: 6px;
  height: 37px;
  min-width: 37px;
  width: 37px;
  text-align: center;
}

.feed-file {
  padding: 5px 5px;
  display: flex;
  text-decoration: none;
  border-radius: 3px;
  cursor: pointer;
  margin: 0 -5px;

  .feed-file-thumbnail {
    width: 40px;
    height: 40px;
    min-width: 40px;
    object-fit: contain;
    margin-right: 5px;
  }

  &:hover {
    background-color: #ddd;
  }
}
</style>